import styled from 'styled-components';
import {Icon, Text} from '@forecast-it/design-system';
import type {TicketSla} from '../types/ticket';
import {slaPresentation} from '../utils/slaPresentation';

/**
 * An SLA is derived (policy plus arrival time), not a control, so it renders as a
 * coloured glyph and a duration — never a pill and never a caret. Each state carries
 * a distinct glyph as well as a distinct colour, so breach and at-risk stay
 * distinguishable in greyscale.
 */
const Row = styled.span`
	display: inline-flex;
	align-items: center;
	gap: ${p => p.theme.sys.spacing[100]};
	white-space: nowrap;
`;

interface Props {
	ticket: {sla: TicketSla | null | undefined};
	/**
	 * Drop the framing words and show the duration alone. For the detail header and
	 * the Details panel, where the ticket is already the subject and "Due in" is
	 * understood; the glyph and its colour still carry the state.
	 */
	compact?: boolean;
}

export function SLABadge({ticket, compact = false}: Props) {
	const {sla} = ticket;
	if (!sla) return null;

	const {state, icon, iconColor, text, compactText} = slaPresentation(sla);
	return (
		<Row data-testid="sla-badge" data-sla-state={state}>
			<Icon icon={icon} size="s" newColor={iconColor} />
			<Text size="2">{compact ? compactText : text}</Text>
		</Row>
	);
}
